"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _ = require("..");

var _UserForm = require("./UserForm.styles");

const EditUserForm = ({
  disabled,
  onChange,
  rolesSelectOptions,
  groupOptions,
  handleToggleDeactivate,
  formData,
  error
}) => {
  const toggleDeactivateStyle = {
    destructive: true,
    additive: false
  };
  let toggleDeactivateText = 'Deactivate User';

  if (formData.status === 'deleted') {
    toggleDeactivateStyle.additive = true;
    toggleDeactivateStyle.destructive = false;
    toggleDeactivateText = 'Reactivate User';
  }

  const userRole = {
    value: formData.role,
    label: formData.role
  };
  const userGroup = groupOptions.reduce((result, groupOption) => {
    var _formData$groups;

    if ((_formData$groups = formData.groups) !== null && _formData$groups !== void 0 && _formData$groups.includes(groupOption.value)) {
      result.push(groupOption);
    }

    return result;
  }, []);

  const formatGroup = selectedGroup => {
    return selectedGroup !== null ? selectedGroup.map(({
      value
    }) => value) : [];
  };

  const formatRole = selectedRole => selectedRole.value;

  const toggleDeactivateParams = [formData.id, formData.email, formData.status];
  return /*#__PURE__*/_react.default.createElement(_UserForm.Container, null, /*#__PURE__*/_react.default.createElement(_.MsgAlert, {
    type: "error",
    message: error
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "UserEditForm"
  }, /*#__PURE__*/_react.default.createElement(_blocks.Button, (0, _extends2.default)({
    thin: true,
    onClick: () => handleToggleDeactivate(...toggleDeactivateParams)
  }, toggleDeactivateStyle), toggleDeactivateText), /*#__PURE__*/_react.default.createElement(_UserForm.Hr, null), /*#__PURE__*/_react.default.createElement(_blocks.FieldText, {
    name: "email",
    type: "email",
    label: "Email",
    placeholder: "Email",
    value: formData.email || '',
    onChange: onChange,
    disabled: disabled || !formData.is_sub_user
  }), /*#__PURE__*/_react.default.createElement(_blocks.FieldText, {
    name: "fullName",
    type: "text",
    label: "Full Name",
    placeholder: "Full Name",
    value: formData.fullName || '',
    onChange: onChange,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_UserForm.Hr, null), /*#__PURE__*/_react.default.createElement(_blocks.FieldSelect, {
    className: "t-SelectRole",
    label: "Role",
    name: "role",
    placeholder: "Select...",
    value: userRole,
    onChange: selectedItem => onChange(formatRole(selectedItem), 'role'),
    options: rolesSelectOptions,
    disabled: disabled,
    menuPosition: "fixed"
  }), /*#__PURE__*/_react.default.createElement(_blocks.FieldSelect, {
    className: "t-SelectGroup",
    label: "Group",
    name: "groups",
    isMulti: true,
    disabled: disabled,
    placeholder: "Select...",
    options: groupOptions,
    value: userGroup,
    onChange: selectedItems => onChange(formatGroup(selectedItems), 'groups'),
    menuPosition: "fixed"
  })));
};

var _default = EditUserForm;
exports.default = _default;
module.exports = exports.default;